<template>
  <div>
    <div class="d-flex justify-space-between align-center">
      <div class="h1">ADD PAYMENT</div>
      <v-icon @click="close">mdi-close</v-icon>
    </div>
    <div>
      <b> Looking for the upgrade option? </b> This person has the following
      status: Miranda Jamieson has passed the Fundamentals Exams, miranda
      Jamieson has not taken the required courses to take the Fundamentals Exam
      and miranda Jamieson has paid the Fundamentals Exam processing file.
    </div>
    <v-divider class="divider"></v-divider>
    <div class="d-flex justify-center mb-9">
      <v-card class="w-100" flat>
        <v-card class="w-100" color="primary" flat>
          <div class="h2 white--text d-flex justify-center align-center py-1">
            Miranda Jamieson
          </div>
        </v-card>
        <div v-show="stepOne">
          <v-row class="mt-4">
            <v-col
              ><div class="d-flex justify-end mx-9">
                <b class="font-18">Payment For:</b>
              </div></v-col
            >
            <v-col>
              <v-radio-group
                v-model="PaymentFor"
                class="pa-0 ma-0"
                hide-details
              >
                <v-radio value="RenewMembership">
                  <template v-slot:label>
                    <div class="mt-1">IBA in-house courses</div>
                  </template>
                </v-radio>
                <v-radio value="CBPExam" class="">
                  <template v-slot:label>
                    <div class="mt-1">PaRama Campus courses</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="my-5">
            <v-row>
              <v-col
                ><div class="d-flex justify-end mx-9">
                  <b class="font-18">Course:</b>
                </div></v-col
              >
              <v-col>
                <v-autocomplete
                  :items="CourseList"
                  multiple
                  label="Course"
                  dense
                  hide-details
                  outlined
                  single-line
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-row>
          <v-row>
            <v-col
              ><div class="d-flex justify-end mx-9">
                <b class="font-18">Payment Option:</b>
              </div></v-col
            >
            <v-col>
              <v-radio-group v-model="PaymentOption" class="pa-0 ma-0">
                <v-radio value="online">
                  <template v-slot:label>
                    <div class="mt-1">ONLINE (Process Credit Card)</div>
                  </template>
                </v-radio>
                <v-radio value="offline" class="">
                  <template v-slot:label>
                    <div class="mt-1">OFFLINE (Add payment record)</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <!--------------------------------Data--Table --------------------------------->
          <table class="w-100 mt-9">
            <tr>
              <th style="width: 30%">
                <div class="d-flex justify-center py-2">Payment Type</div>
              </th>
              <th><div class="d-flex justify-center py-2">Courses</div></th>
              <th style="width: 30%">
                <div class="d-flex justify-center py-2">Price</div>
              </th>
            </tr>
            <tr>
              <td>
                <div class="d-flex justify-center py-2">Renew Membership</div>
              </td>

              <td>
                <div class="d-flex justify-center py-2">PaRama</div>
              </td>
              <td><div class="d-flex justify-center py-2">$ 300.00</div></td>
            </tr>
            <tr>
              <td>
                <div class="d-flex justify-center py-2">Upgrade Membership</div>
              </td>

              <td>
                <div class="d-flex justify-center py-2">ADV</div>
              </td>
              <td><div class="d-flex justify-center py-2">$ 300.00</div></td>
            </tr>
          </table>
        </div>
        <div v-show="stepTwo">
          <v-card
            class="w-100 h2 white--text d-flex justify-center align-center py-1"
            flat
            color="primary"
            ><span class="white--text">ONLINE PROCESS</span></v-card
          >
          <div class="font-18 my-3"><b>Payment Information</b></div>
          <v-row>
            <v-col cols="12" md="5">
              <div class="d-flex">
                <div class="mr-3">Current Membership:</div>
                <div><b>Instructor</b></div>
              </div>
            </v-col>
            <v-col cols="12" md="7">
              <div class="d-flex">
                <div class="mr-3">Description:</div>
                <div>
                  <b>Renew membership from 04 June,2022 to 04 04 June, 2023</b>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2"
              ><div class="d-flex">
                <b class="font-18">Fee:</b>
              </div></v-col
            >
            <v-col cols="10">
              <v-radio-group v-model="PaymentInformationFee" class="pa-0 ma-0">
                <v-radio value="standardmembership">
                  <template v-slot:label class="d-flex">
                    <v-row>
                      <v-col>
                        <div class="mt-2 black--text">Standard Membership</div>
                      </v-col>
                      <v-col>
                        <div class="mt-2 black--text">$ 150.00</div>
                      </v-col>
                    </v-row>
                  </template>
                </v-radio>
                <v-radio value="practicingmembership">
                  <template v-slot:label class="d-flex">
                    <v-row>
                      <v-col>
                        <div class="mt-2 black--text">
                          Practicing Membership
                        </div>
                      </v-col>
                      <v-col>
                        <div class="mt-2 black--text">$ 300.00</div>
                      </v-col>
                    </v-row>
                  </template>
                </v-radio>
                <v-radio value="instructormembership">
                  <template v-slot:label class="d-flex">
                    <v-row>
                      <v-col>
                        <div class="mt-2 black--text">Instructor</div>
                      </v-col>
                      <v-col>
                        <div class="mt-2 black--text">$ 300.00</div>
                      </v-col>
                    </v-row>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <div class="font-18 my-8 d-flex justify-space-between">
            <b>Billing Address</b>
            <span class="primary--text cursor-pointer">Use Member Address</span>
          </div>
          <div>
            <v-row>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Address:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Address:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="my-7">
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">City:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">State:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Zip:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Country:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>

          <v-divider class="divider mt-9"></v-divider>
          <div class="font-18 my-8">
            <b>Credit Card Information</b>
          </div>
          <div>
            <v-row>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">First Name:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Last Name:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="my-7">
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">CC Type:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Number:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">CVV Code:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Expiration Date:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date"
                          label="Picker in menu"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          hide-details
                          dense
                          outlined
                          single-line
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="d-flex justify-space-between mt-11">
          <div>
            <v-btn
              color="primary"
              class="px-9"
              v-show="this.stepTwo == true"
              @click="GoBack()"
              >Back</v-btn
            >
          </div>
          <div>
            <v-btn
              color="primary"
              class="px-9"
              v-if="this.PaymentOption === 'offline' || this.stepTwo == true"
              @click="Submit()"
              >Submit</v-btn
            >
            <v-btn
              color="primary"
              class="px-9"
              v-if="this.PaymentOption === 'online'"
              v-show="this.stepTwo == false"
              @click="GoToStepTwo()"
              >Next
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["CourseTaughtPaymentProcess"],
  name: "CoursesTaughtPaymentComponent",
  data() {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      PaymentFor: [],
      PaymentOption: [],
      PaymentInformationFee: [],
      stepOne: true,
      stepTwo: false,
      CourseList: ["CBP", "CBP-A", "ADV", "PaRama"],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    Submit() {
      this.close();
    },
    GoToStepTwo() {
      this.stepOne = false;
      this.stepTwo = true;
    },
    GoBack() {
      this.stepTwo = false;
      this.stepOne = true;
    },
  },
};
</script>

<style scoped>
.h1 {
  font-size: 26px;
  font-weight: 700;
}
.h2 {
  font-size: 22px;
  font-weight: 700;
}
.font-18 {
  font-size: 18px;
}
table,
td,
th {
  border: 1px solid;
}
th {
  background-color: #cccccc;
}
.divider {
  border-color: #e6e6e6;
}
</style>
